import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { SharedServices } from '../../../../services/shared.services'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import * as parser from 'ua-parser-js'
import { onsNotification } from 'ngx-onsenui'
import { tokenDeviceUrl } from '../../../../../helper/common'

@Component({
    selector: 'app-device',
    templateUrl: './device.component.html',
    styleUrls: ['./device.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class DeviceComponent implements OnInit {
    en = {}
    showEN = true
    arrayType = [{ type: 'qrcode', text: 'QR code', action: true }, {
        type: 'mail',
        text: 'Mail',
        action: false,
    }, { type: 'text', text: 'Text', action: false }]
    acctionActive = 'qrcode'
    idClient
    clientIdParam
    listDevice
    listDeviceSort
    testUA = new parser()
    accountId
    tokenDeviceUrl = tokenDeviceUrl
    disableEnvelope: boolean
    origin: string

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private route: ActivatedRoute) {
        _sharedService.changeEmittedSource$.subscribe(
            success => {
                this.listDevice = success
                this.listDeviceSort = this.listDevice.sort(function(time1, time2) {
                    if (time1.createTime > time2.createTime) {
                        return -1
                    } else if (time1.createTime < time2.createTime) {
                        return 1
                    } else {
                        return 0
                    }
                })
            })
        this.accountId = this.authData.getUser()._id
    }

    ngOnInit() {
        this.route.parent.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.idClient = id
            this.clientIdParam = '{"clientId":"' + [this.idClient] + '"}'
        })
        this.mainClient()
        let reloadPage = setInterval(() => {
            const user = this.authData.getUser();
            if (user) {
                const expires = parseInt((user.expiresInSeconds)) * 1000
                const timeOut = parseInt(this.authData.getItem('timeout')) + expires
                const timeNow = Date.now()
                if (timeOut > (timeNow + 6000)) {
                    this.reloadData()
                } else {
                    clearInterval(reloadPage)
                }
            }
        }, 3000)
        this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success && success[0] == 'activeDevicePage' && success[1] == false)
                    // this.listDevice = success;
                    clearInterval(reloadPage)
            })
        this.origin = window.location.origin
        // clearInterval(reloadPage);
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    checkAction(type, array) {
        this.acctionActive = type
        array.forEach(function(val) {
            if (val.type === type) {
                if (val.action) {
                    val.action = false
                } else {
                    val.action = true
                }
            }
        })
        array.forEach(function(val) {
            if (val.type !== type) {
                val.action = false
            }
        })
    }

    mainClient() {

        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                client: {
                    map: { [this.idClient]: true },
                    paths: { '{}': true },
                },
                clientDevice: {
                    paths: { [this.clientIdParam]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const client = success['response']['client']['map'][this.idClient]
                    this.disableEnvelope = !(!!client['email1'] || !!client['email2'])
                    this.listDevice = success['response']['clientDevice']['paths'][this.clientIdParam]
                    this.listDeviceSort = this.listDevice.sort(function(time1, time2) {
                        if (time1.createTime > time2.createTime) {
                            return -1
                        } else if (time1.createTime < time2.createTime) {
                            return 1
                        } else {
                            return 0
                        }
                    })
                },
            )
        })
    }

    readUA(stringUA) {
        this.testUA.setUA(stringUA)
        //
        let Device = this.testUA.getResult().device
        let Os = this.testUA.getResult().os
        //
        if (stringUA) {
            let isApp = (Os.name == 'Android' || Os.name == 'iOS') ? '(App)' : '(Web)'
            return (Device.model || '') + ' ' + (Os.name || '') + ' ' + (Os.version || '') + isApp
        } else {
            return ''
        }
    }

    openDeviceInfoModal(device) {
        const arrayActiveModal = ['activeModalDeviceInfo', device]
        this._sharedService.emitChange(arrayActiveModal)
    }


    openModalQRcode(device) {
        const arrayActiveModal = ['activeModalDeviceQR', device, this.accountId]
        this._sharedService.emitChange(arrayActiveModal)
    }

    newDevice() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [
                {
                    collection: 'clientDevice',
                    type: 'create',
                    value: {
                        clientId: this.idClient,
                    },
                },
            ],
            status: {
                client: {
                    map: { [this.idClient]: true },
                    paths: { '{}': true },
                },
                clientDevice: {
                    paths: { [this.clientIdParam]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    if (success['status'] === 'OK') {
                        this._sharedService.emitChangeParent(success['response']['clientDevice']['paths'][this.clientIdParam])
                    }
                },
            )
        })
    }

    reloadData() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                clientDevice: {
                    paths: { [this.clientIdParam]: true },
                }
            },
        }
        const tokenNow = this.authData.getItem('token');
        this.restApi.http_post(resourceUrl, resourceData, tokenNow).subscribe(
            success => {
                let result_sort = success['response']['clientDevice']['paths'][this.clientIdParam].sort(function(time1, time2) {
                    if (time1.createTime > time2.createTime) {
                        return -1
                    } else if (time1.createTime < time2.createTime) {
                        return 1
                    } else {
                        return 0
                    }
                })
                if (success['status'] === 'OK') {
                    if (!(JSON.stringify(this.listDevice) == JSON.stringify(result_sort))) {
                        this._sharedService.emitChangeParent(success['response']['clientDevice']['paths'][this.clientIdParam])
                    }
                }
            }
        )
    }

    copyToken() {
        document.execCommand('copy')
        // let navigatorTsIssue: any;
        // navigatorTsIssue = window.navigator;
        //
        // document.execCommand('copy');
        // navigatorTsIssue.clipboard.readText().then(
        //     clipText => {
        //         navigatorTsIssue.clipboard.writeText(window.location.origin + clipText)
        //     });
    }

    sendDeviceMail(token: string) {
        const resourceData = {
            type: 'deviceMail',
            clientId: this.idClient,
            deviceUrl: this.origin + this.tokenDeviceUrl + (this.accountId || '') + '/' + token,
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('mails/device-mail', resourceData, tokenReNew).subscribe(
                success => {
                })
        })
    }

    showDeviceMailNotification(token: string) {
        if (!this.disableEnvelope) {
            onsNotification.confirm(
                {
                    message: this.en['client-detail-profile-confirm-device-mail-message'],
                    title: '<b>' + this.en['client-detail-profile-confirm-device-mail-title'] + '</b>',
                    buttonLabels: [this.en['client-detail-profile-confirm-submit-lable-cancel'], this.en['client-detail-profile-confirm-submit-lable-ok']],
                    modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.
                            this.sendDeviceMail(token)
                        }
                    },
                })
        }
    }

    activeDevice(activeCode, device) {
        if (parseInt(activeCode) === device.activationCode) {

            let resourceUrl = 'resource'
            let resourceData = {
                actions: [
                    {
                        collection: 'clientDevice',
                        id: device._id,
                        type: 'update',
                        value: {
                            status: 'activated',
                        },
                    },
                ],
                status: {
                    client: {
                        map: { [this.idClient]: true },
                        paths: { '{}': true },
                    },
                    clientDevice: {
                        paths: { [this.clientIdParam]: true },
                    },
                    clinic: {
                        paths: {
                            '{}': true,
                        },
                    },
                    setting: {
                        map: {
                            common: true,
                        },
                        paths: {
                            '{}': true,
                        },
                    },
                    staff: {
                        paths: {
                            '{"roles":"cordinator"}': true,
                            '{"roles":"doctor"}': true,
                            '{}': true,
                        },
                    },
                },
            }
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                    success => {
                        if (success['status'] === 'OK') {
                            this._sharedService.emitChangeParent(success['response']['clientDevice']['paths'][this.clientIdParam])
                        }
                    },
                )
            })
        } else {

            onsNotification.alert(this.en['client-detail-device-activation-alert-err'], { title: '<b>Error</b>' })
            // if(localStorage.lang==="true") {
            //     onsNotification.alert('Invalid Activation code', {title: '<b>Error</b>'});
            // }
            // else{
            //     onsNotification.alert('無効なアクティベーションコード', {title: '<b>Error</b>'});
            // }
        }
    }

}




// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/device/device.component.ts